// startup
// Load entry module
__webpack_require__("./src/client/index.tsx");
// This entry module used 'exports' so it can't be inlined
